import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // Reverted import

// Your web app's Firebase configuration
// Get this from your Firebase project settings > General
const firebaseConfig = {
  apiKey: "AIzaSyD2ty1cyScK6sDe27gJcbIO-bXo5JSgkds",
  authDomain: "pre-intake-app.firebaseapp.com",
  projectId: "pre-intake-app",
  storageBucket: "pre-intake-app.firebasestorage.app",
  messagingSenderId: "914390762195",
  appId: "1:914390762195:web:12389843168870a7588a26",
  measurementId: "G-VH3YMH8X8M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app); // Reverted to standard getAuth
